import React, { Component } from 'react'
import Wrapper from '../../../hoc/Wrapper'
import Backdrop from '../Backdrop/Backdrop'
import './Modal.scss'

class Modal extends Component {
  constructor() {
    super();
    this.state = {
      modalclass: 'Modal'
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.className !== prevProps.className) {
      this.setState({
        modalclass: 'Large-Modal'
      })
    }
  }
  render() {
    return (
      <Wrapper>
        <Backdrop show={this.props.show} clicked={this.props.modalClosed} />
        <div className={this.props.className ? this.props.className : 'Modal'}
          style={{
            transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
            opacity: this.props.show ? '1' : '0'
          }}>
          <div>
            {this.props.children}
          </div>
        </div>
      </Wrapper>
    )
  }
}

export default Modal
export const testingAbsoluteImport = true
